import Embed from './Embed';

export default {
  Embed,
};
